import { gql } from "@apollo/client";

const START_ADD_PAYMENT_METHOD = gql`
  mutation StartAddPaymentMethod {
    startAddPaymentMethod
  }
`;

const COMPLETE_ADD_PAYMENT_METHOD = gql`
  mutation CompleteAddPaymentMethod($orderId: String!) {
    completeAddPaymentMethod(orderId: $orderId) {
      id
      maskedPan
      expiration
    }
  }
`;

const UPDATE_BILLING_INFO = gql`
  mutation UpdateBillingInfo($input: BillingInfoArgs!) {
    updateBillingInfo(input: $input) {
      id
      firstName
      lastName
      address
      country
      countryId
      state
      stateId
      city
      cityId
      postCode
      email
      phone
      companyLegalName
      companyVatNumber
    }
  }
`;

const REMOVE_PAYMENT_METHOD = gql`
  mutation RemovePaymentMethod($removePaymentMethodId: ID!) {
    removePaymentMethod(id: $removePaymentMethodId)
  }
`;

const INITIATE_WALLET_TOP_UP = gql`
  mutation InitiateWalletTopUp($amount: Float!, $currency: String, $pageView: PageView) {
    initiateWalletTopUp(amount: $amount, currency: $currency, pageView: $pageView)
  }
`;
 
const COMPLETE_WALLET_TOP_UP = gql`
  mutation CompleteWalletTopUp($btOrderId: String!) {
    completeWalletTopUp(btOrderId: $btOrderId) {
      status
      balance
      transaction {
        id
        type
        amount
        balanceAfter
        createdAt
        description
      }
    }
  }
`;
 

export {
  START_ADD_PAYMENT_METHOD,
  UPDATE_BILLING_INFO,
  REMOVE_PAYMENT_METHOD,
  COMPLETE_ADD_PAYMENT_METHOD,
  INITIATE_WALLET_TOP_UP,
  COMPLETE_WALLET_TOP_UP
};
